// extracted by mini-css-extract-plugin
export default {"notification":"emptyParentNodeTip_notification__4oE0h"};